import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { FC, useMemo } from "react";
import { Requirement } from "../../../../types/requirement";
import { CustomLabel } from "types/CustomLabel";
import {
  getRequirementEvaluationMetrics,
  getSkillLevelRatingOptions,
} from "helpers/customLabels";

type RateSelectorProps = {
  value: any;
  onChange?: (value: number) => void;
  requirement: Requirement | null;
  customLabels?: CustomLabel[];
};

export const RateSelector: FC<RateSelectorProps> = ({
  value,
  onChange,
  requirement,
  customLabels = [],
}) => {
  const options = useMemo(
    () =>
      getSkillLevelRatingOptions(
        requirement?.type,
        getRequirementEvaluationMetrics(requirement),
        customLabels,
      ),
    [customLabels, requirement],
  );

  return (
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={(_, nextValue) => {
        onChange?.(nextValue);
      }}
      orientation="vertical"
    >
      {options.map((opt) => (
        <ToggleButton
          value={opt.value}
          key={opt.value}
          sx={{ justifyContent: "flex-start", textAlign: "left" }}
        >
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
